/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.PaymentType {
    'use strict';

    export class PaymentTypeContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {
        constructor(
            appSettings: Meevo.Components.Common.IAppSettings,
            dataService: Meevo.Components.BaseClasses.IDataService,
            modalService: Meevo.Components.Modal.IModalService,
            identityService: Meevo.Components.Common.IIdentityService,
            loggingService: Meevo.Components.Logging.ILoggingService,
            securityChecker: Meevo.Components.Common.ISecurityService,
            trackingService: Meevo.Components.Tracking.ITrackingService,
            rootScope: ng.IRootScopeService
        ) {
            super(
                appSettings,
                dataService,
                modalService,
                identityService,
                loggingService,
                securityChecker,
                trackingService
            );

            this.baseEndpoint = this.appSettings.API_ENDPOINTS.paymentType;
            this.sectionTemplatePath = 'app/plugins/paymentType/sectionViews/';
            this.buildCrudSecurityKeys(this.securityKeys.DATA_PAYMENTTYPE_TAB_MAIN);
            this.changeOwnerSecurityKey;
            this.entityType = 'PaymentType';
        }

        initializeSections(): void {
            if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.DATA_PAYMENTTYPE_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
                this.sections.push(
                    new MainSection(
                        0,
                        'SECTION_PAYMENTTYPE_MAIN',
                        'main.html',
                        true,
                        false,
                        this.appSettings.API_ENDPOINTS.paymentType,
                        '',
                        this.loggingService,
                        this.dataService,
                        this.identityService,
                        Meevo.Model.NounEnum.PaymentTypeMain,
                        null,
                        this.securityKeys.DATA_PAYMENTTYPE_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ
                    )
                );
            }
        }

        initializeHeader(model: any): void {
            this.headerContent = model.displayName;
        }

        isFieldDisabledForEditViaSecurity(keyName: string, isDisabled: boolean): boolean {
            return (
                !this.isAdding &&
                (!this.securityChecker.hasSecurity(keyName + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE) || isDisabled)
            );
        }

        save(): angular.IPromise<any> {
            if (this.mode == Meevo.Model.MaintenanceFormState.Adding) {
                super.usageTrackingLog(Model.VerbEnum.Created, null);
            }
            return super.save();
        }

        get canDelete(): boolean {
            return (
                this.isReadonly &&
                this.itemId !== Guid.empty &&
                this.verifySelectedSectionModel() &&
                this.selectedSection.isPrimarySection &&
                !this.selectedSection.handlesOwnCrud &&
                this.selectedSection.model.objectState !== Model.ObjectStateEnum.Deleted &&
                this.selectedSection.model.objectState !== Model.ObjectStateEnum.Merge &&
                !this.castModel<Model.PaymentType>().paymentTypeSId
            );
        }

        get showCopy(): boolean {
            return false;
        }

        get canCopy(): boolean {
            return false;
        }

        paymentTypeTempSave: any = undefined;

        postAdd(model: any): void {
            this.paymentTypeTempSave = model.meevoFile;
            model.isStorageUpdated = false;
            super.postAdd(model);
        }

        postUpdate(model: any): void {
            model.isStorageUpdated = false;
            super.postUpdate(model);
        }

        postCancel(): void {
            let model = this.castModel<Model.PaymentType>();
            if (this.paymentTypeTempSave) {
                model.meevoFile = this.paymentTypeTempSave;
                model.isStorageUpdated = false;
            }

            // no need to call the Storage API if there's no image to delete
            if (model && model.fileGuid) {
                let deleteJson = {
                    FileGuid: model.fileGuid,
                    LocationId: model.locationId,
                    ResourceType: <Meevo.Model.FileTypes>Meevo.Model.FileTypes['PaymentTypeImage'],
                };
                //this.dataService.delete("Storage", this.model.fileGuid, this.model.entityVersion, this.model.locationId);
                //this.dataService.deleteWithJsonBody("Storage", deleteJson);
                this.dataService.deleteFile(model.meevoFile.config.endPoint, deleteJson);
            }
            super.postCancel();
        }

        postCopy(): void {
            let model = this.castModel<Model.PaymentType>();
            model.meevoFile = undefined;
            model.isStorageUpdated = false;
            model.fileGuid = undefined;
        }

        getPaymentTypeUrl(paymentTypeSId: number): string {
            switch (paymentTypeSId) {
                case 1:
                    return 'assets/images/icons/payment_cash.svg';
                case 2:
                    return 'assets/images/icons/payment_visa.svg';
                case 3:
                    return 'assets/images/icons/payment_mastercard.svg';
                case 4:
                    return 'assets/images/icons/payment_amex.svg';
                case 5:
                    return 'assets/images/icons/payment_discover.svg';
                case 6:
                    return 'assets/images/icons/payment_debit.svg';
//              case 7:
//                  return 'assets/images/icons/payments_giftcard.svg';
                case 8:
                    return 'assets/images/icons/payment_check.svg';
            }
            return null;
        }

        bindPaymentTypePhoto(url: string) {
            let model = this.castModel<Model.PaymentType>();
            if (model) {
                let url = this.getPaymentTypeUrl(model.paymentTypeSId);
                let fMetadata = this.castModel<Model.IStorageFile>();
                if (fMetadata) {
                    url = this.searchFile(fMetadata, 'Formated', url);
                }
            }
            return url;
        }

        fileTypesEnum = Meevo.Model.FileTypes;
    }
}
